// baseurl.js

// Backend API base URL
export const baseurl = "https://backend.topairview.com/api/"; 
// export const baseurl = "https://top.astromaster.online/api/"; 
// export const baseurl = "http://localhost:5000/api/"; 

// Image base URL (for static uploads)
export const imgurl = "https://backend.topairview.com/"; 
// export const imgurl = "https://top.astromaster.online/"; 
// export const imgurl = "http://localhost:5000/"; 
